import {
    Component,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseSlotComponent } from '../base-slot.component';
import { ZardSelectComponent } from '../../../ui/select/select.component';
import { ZardSelectItemComponent } from '../../../ui/select/select-item.component';

@Component({
    selector: 'select-slot',
    templateUrl: './select-slot.component.html',
    standalone: true,
    imports: [
        ZardSelectComponent,
        ZardSelectItemComponent,
        ReactiveFormsModule,
    ],
})
export class SelectSlotComponent
    extends BaseSlotComponent
{
}
